// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"0777317b","67":"6d63c744","375":"42d3c6f7","453":"b1b653c5","549":"1d3b1d64","781":"bef07d20"}[chunkId] + ".chunk.js";
};